<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        class="ant-advanced-search-form"
        layout="inline"
        :form="form"
        @submit="handleSearch"
      >
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="服务名称">
              <a-input
                placeholder="请输入服务名称"
                v-decorator="['serveName']"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="接口名称">
              <a-input
                placeholder="请输入接口名称"
                v-decorator="['interfaceName']"
              ></a-input>
            </a-form-item>
          </a-col>
          <template v-if="expand">
            <a-col :md="6" :sm="8">
              <a-form-item label="接口地址">
                <a-input
                  placeholder="请输入接口地址"
                  v-decorator="['interfaceUrl']"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="接口描述">
                <a-input
                  placeholder="请输入接口描述"
                  v-decorator="['interfaceDesc']"
                ></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="handleReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="toggle" style="margin-left: 8px">
                {{ expand ? '收起' : '展开' }}
                <a-icon :type="expand ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary">更新接口数据</a-button>
      <a-button @click="getAuthorized" type="primary" icon="plus"
        >qweq</a-button
      >
    </div>

    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        size="middle"
        bordered
        :columns="columns"
        :data-source="dataList"
        rowKey="id"
        :scroll="{ x: 1000 }"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="getAuthorized(record)">已授权应用</a>
        </span>
      </a-table>
    </div>
    <authorized-modal ref="authorized"></authorized-modal>
  </a-card>
</template>

<script>
const columns = [
  {
    align: 'center',
    title: '服务',
    dataIndex: 'title',
    key: 'title',
    width: 200,
  },
  {
    align: 'center',
    title: '接口名',
    dataIndex: 'channelColumnList',
    width: 200,
  },
  {
    align: 'center',
    title: '接口地址',
    dataIndex: 'author',
    width: 200,
  },
  {
    align: 'center',
    title: '接口描述',
    dataIndex: 'createTime',
    width: 200,
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    fixed: 'right',
    scopedSlots: {
      customRender: 'operation',
    },
  },
];

import authorizedModal from './authorizedModal';
export default {
  data() {
    return {
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns,
      form: this.$form.createForm(this),
      expand: false,
      selectedRowKeys: [],
      selectedRows: [],
      dataList: [],
      loading: false,
    };
  },
  components: {
    authorizedModal,
  },
  created() {},
  methods: {
    handleSearch() {},
    handleReset() {
      this.form.setFieldsValue();
    },
    toggle() {
      this.expand = !this.expand;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
    },
    getAuthorized() {
      this.$refs.authorized.checkApp();
    },
  },
};
</script>

<style scoped lang="less">
.table-operator {
  margin-bottom: 10px;
}
</style>
